<sb-dashboard-widget
  [isEmpty]="birthdays().length === 0"
  [title]="'Birthdays' | translate"
  [emptySettings]="{
    description: 'No birthdays yet — they\'ll appear here once added to profiles.' | translate,
    icon: 'celebrate-cute-re',
  }"
>
  <sb-dashboard-widget-select
    [options]="periodOptions"
    [model]="widgetPeriod()"
    (modelChange)="onPeriodChange($event)"
    [label]="'Next' | translate"
  />

  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th class="row-50">{{ 'Name' | translate }}</th>
        <th class="row-20">{{ 'Date' | translate }}</th>
        <th class="row-30">{{ 'New age' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (birthday of birthdays(); track birthday.id) {
        <tr>
          <td>{{ birthday.name }}</td>
          <td>{{ birthday.birthday | localeDate: 'medium' }}</td>
          <td>{{ birthday.birthday_age }}</td>
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
